// The map catalogue: named maps players pick from, each with the most cities it splits fairly into.
// Generated by scripts/build_maps.mjs; real places come from src/sim/places.js.
export const MAPS = [
  {"seed":40,"name":"Great Britain","form":"real","max":23},
  {"seed":144,"name":"Ireland","form":"real","max":30},
  {"seed":63,"name":"Iceland","form":"real","max":12},
  {"seed":151,"name":"Sicily","form":"real","max":30},
  {"seed":30,"name":"Sardinia","form":"real","max":30},
  {"seed":82,"name":"Corsica","form":"real","max":30},
  {"seed":2,"name":"Crete","form":"real","max":19},
  {"seed":31,"name":"Cyprus","form":"real","max":15},
  {"seed":33,"name":"Mallorca","form":"real","max":30},
  {"seed":28,"name":"Tasmania","form":"real","max":30},
  {"seed":78,"name":"North Island","form":"real","max":6},
  {"seed":55,"name":"South Island","form":"real","max":30},
  {"seed":79,"name":"Sri Lanka","form":"real","max":16},
  {"seed":6,"name":"Madagascar","form":"real","max":30},
  {"seed":5,"name":"Cuba","form":"real","max":9},
  {"seed":13,"name":"Taiwan","form":"real","max":30},
  {"seed":76,"name":"Hokkaido","form":"real","max":12},
  {"seed":64,"name":"Long Island","form":"real","max":11},
  {"seed":16,"name":"Isle of Wight","form":"real","max":30},
  {"seed":35,"name":"Honshu","form":"real","max":30},
  {"seed":53,"name":"Jamaica","form":"real","max":30},
  {"seed":184,"name":"Trinidad","form":"real","max":18},
  {"seed":15,"name":"Borneo","form":"real","max":30},
  {"seed":54,"name":"Newfoundland","form":"real","max":11},
  {"seed":1,"name":"Penhallow Fjords","form":"fjords","max":30},
  {"seed":3,"name":"Larch Bay","form":"bay","max":30},
  {"seed":4,"name":"Kettle Bay","form":"bay","max":30},
  {"seed":7,"name":"Brindle Bay","form":"bay","max":30},
  {"seed":8,"name":"Ivel Lagoon","form":"lagoon","max":30},
  {"seed":9,"name":"Mossley Lagoon","form":"lagoon","max":30},
  {"seed":11,"name":"Rookmoor Twin Isles","form":"twin","max":30},
  {"seed":12,"name":"Mossley Twin Isles","form":"twin","max":30},
  {"seed":18,"name":"Saltash Fjords","form":"fjords","max":30},
  {"seed":22,"name":"Ivel Coast","form":"coast","max":30},
  {"seed":23,"name":"Saltash Lagoon","form":"lagoon","max":30},
  {"seed":25,"name":"Ashby Twin Isles","form":"twin","max":30},
  {"seed":34,"name":"Brindle Island","form":"island","max":30},
  {"seed":38,"name":"Wexley Fjords","form":"fjords","max":30},
  {"seed":48,"name":"Farrow Coast","form":"coast","max":30},
  {"seed":50,"name":"Vane Coast","form":"coast","max":30},
  {"seed":81,"name":"Ivel Island","form":"island","max":30},
  {"seed":84,"name":"Thistle Island","form":"island","max":30},
];
